import { player as RTCPlayer } from './player.js';

let webRtcPlayerObj = null;
let print_inputs = false;
const WS_OPEN_STATE = 1;

let qualityController = false;
let qualityControlOwnershipCheckBox;
let matchViewportResolution = true;
// TODO: Remove this - workaround because of bug causing UE to crash when switching resolutions too quickly
let lastTimeResized = new Date().getTime();
let resizeTimeout;

let responseEventListeners = new Map();

let freezeFrameOverlay = null;
// A freeze-frame is a still JPEG image shown instead of the video.
let freezeFrame = {
	receiving: false,
	size: 0,
	jpeg: undefined,
	height: 0,
	width: 0,
	valid: false
};

let file = {
	mimetype: '',
	extension: '',
	receiving: false,
	size: 0,
	data: [],
	valid: false,
	timestampStart: undefined
};

var script = document.createElement('script');
script.src = 'https://code.jquery.com/jquery-3.4.1.min.js';
script.type = 'text/javascript';
document.getElementsByTagName('head')[0].appendChild(script);

function setupHtmlEvents() {
	//Window events
	window.addEventListener('resize', resizePlayerStyle, true);

	let resizeCheckBox = document.getElementById(
		'enlarge-display-to-fill-window-tgl'
	);
	if (resizeCheckBox !== null) {
		resizeCheckBox.onchange = function() {
			resizePlayerStyle();
		};
	}

	qualityControlOwnershipCheckBox = document.getElementById(
		'quality-control-ownership-tgl'
	);

	if (qualityControlOwnershipCheckBox !== null) {
		qualityControlOwnershipCheckBox.onchange = function() {
			requestQualityControl();
		};
	}
}

function setOverlay(htmlClass, htmlElement, onClickFunction) {
	let videoPlayOverlay = document.getElementById('videoPlayOverlay');
	if (!videoPlayOverlay) {
		let playerDiv = document.getElementById('player');
		videoPlayOverlay = document.createElement('div');
		videoPlayOverlay.id = 'videoPlayOverlay';
		playerDiv.appendChild(videoPlayOverlay);
	}

	// Remove existing html child elements so we can add the new one
	while (videoPlayOverlay.lastChild) {
		videoPlayOverlay.removeChild(videoPlayOverlay.lastChild);
	}

	if (htmlElement) {
		videoPlayOverlay.appendChild(htmlElement);
	}

	if (onClickFunction) {
		videoPlayOverlay.addEventListener('click', function onOverlayClick(event) {
			onClickFunction(event);
			videoPlayOverlay.removeEventListener('click', onOverlayClick);
		});
	}

	// Remove existing html classes so we can set the new one
	let cl = videoPlayOverlay.classList;
	for (let i = cl.length - 1; i >= 0; i--) {
		cl.remove(cl[i]);
	}

	videoPlayOverlay.classList.add(htmlClass);
}

function playVideoStream() {
	if (webRtcPlayerObj && webRtcPlayerObj.video) {
		webRtcPlayerObj.video.play().catch(onRejectedReason => {
			console.error(onRejectedReason);
			console.log(
				'Browser does not support autoplaying video without interaction - to resolve this we are going to show the play button overlay.'
			);
			showPlayOverlay();
		});

		requestInitialSettings();
		requestQualityControl();
		showFreezeFrameOverlay();
		// hideOverlay();
	} else {
		console.error(
			'Could not player video stream because webRtcPlayerObj.video was not valid.'
		);
	}
}

function showPlayOverlay() {
	let img = document.createElement('img');
	img.id = 'playButton';
	img.src = '/images/Play.png';
	img.alt = 'Start Streaming';
	setOverlay('clickableState', img, () => {
		playVideoStream();
	});
}

function sendInputData(data) {
	if (webRtcPlayerObj) {
		webRtcPlayerObj.send(data);
	}
}

// Must be kept in sync with PixelStreamingProtocol::EToPlayerMsg C++ enum.
const ToClientMessageType = {
	QualityControlOwnership: 0,
	Response: 1,
	Command: 2,
	FreezeFrame: 3,
	UnfreezeFrame: 4,
	VideoEncoderAvgQP: 5,
	LatencyTest: 6,
	InitialSettings: 7,
	FileExtension: 8,
	FileMimeType: 9,
	FileContents: 10
};

let VideoEncoderQP = 'N/A';

function setupWebRtcPlayer(ws, htmlElement, config) {
	webRtcPlayerObj = new RTCPlayer(config);
	htmlElement.appendChild(webRtcPlayerObj.video);
	htmlElement.appendChild(freezeFrameOverlay);

	webRtcPlayerObj.onWebRtcOffer = function(offer) {
		if (ws && ws.readyState === WS_OPEN_STATE) {
			let offerStr = JSON.stringify(offer);
			console.log(
				'%c[Outbound SS message (offer)]',
				'background: lightgreen; color: black',
				offer
			);
			ws.send(offerStr);
		}
	};

	webRtcPlayerObj.onWebRtcCandidate = function(candidate) {
		if (ws && ws.readyState === WS_OPEN_STATE) {
			ws.send(
				JSON.stringify({
					type: 'iceCandidate',
					candidate: candidate
				})
			);
		}
	};

	webRtcPlayerObj.onWebRtcAnswer = function(answer) {
		if (ws && ws.readyState === WS_OPEN_STATE) {
			let answerStr = JSON.stringify(answer);
			console.log(
				'%c[Outbound SS message (answer)]',
				'background: lightgreen; color: black',
				answer
			);
			ws.send(answerStr);
		}
	};

	webRtcPlayerObj.onVideoInitialised = function() {
		if (ws && ws.readyState === WS_OPEN_STATE) {
			resizePlayerStyle();
			playVideoStream();
		}
	};

	webRtcPlayerObj.onDataChannelConnected = function() {
		if (ws && ws.readyState === WS_OPEN_STATE) {
			requestQualityControl();
		}
	};

	function showFreezeFrame() {
		let base64 = btoa(
			freezeFrame.jpeg.reduce(
				(data, byte) => data + String.fromCharCode(byte),
				''
			)
		);
		let freezeFrameImage = document.getElementById('freezeFrameOverlay')
			.childNodes[0];
		freezeFrameImage.src = 'data:image/jpeg;base64,' + base64;
		freezeFrameImage.onload = function() {
			freezeFrame.height = freezeFrameImage.naturalHeight;
			freezeFrame.width = freezeFrameImage.naturalWidth;
			resizeFreezeFrameOverlay();
			showFreezeFrameOverlay();
			webRtcPlayerObj.setVideoEnabled(false);
		};
	}

	function processFileExtension(view) {
		// Reset file if we got a file message and we are not "receiving" it yet
		if (!file.receiving) {
			file.mimetype = '';
			file.extension = '';
			file.receiving = true;
			file.valid = false;
			file.size = 0;
			file.data = [];
			file.timestampStart = new Date().getTime();
			console.log('Received first chunk of file');
		}

		let extensionAsString = new TextDecoder('utf-16').decode(view.slice(1));
		console.log(extensionAsString);
		file.extension = extensionAsString;
	}

	function processFileMimeType(view) {
		// Reset file if we got a file message and we are not "receiving" it yet
		if (!file.receiving) {
			file.mimetype = '';
			file.extension = '';
			file.receiving = true;
			file.valid = false;
			file.size = 0;
			file.data = [];
			file.timestampStart = new Date().getTime();
			console.log('Received first chunk of file');
		}

		let mimeAsString = new TextDecoder('utf-16').decode(view.slice(1));
		console.log(mimeAsString);
		file.mimetype = mimeAsString;
	}

	function processFileContents(view) {
		// If we haven't received the intial setup instructions, return
		if (!file.receiving) {
			return;
		}

		// Extract the toal size of the file (across all chunks)
		file.size = Math.ceil(
			new DataView(view.slice(1, 5).buffer).getInt32(0, true) /
				16379 /* The maximum number of payload bits per message*/
		);

		// Get the file part of the payload
		let fileBytes = view.slice(1 + 4);

		// Append to existing data that holds the file
		file.data.push(fileBytes);

		// Uncomment for debug
		console.log(`Received file chunk: ${file.data.length}/${file.size}`);

		if (file.data.length === file.size) {
			file.receiving = false;
			file.valid = true;
			console.log('Received complete file');
			const transferDuration = new Date().getTime() - file.timestampStart;
			const transferBitrate = Math.round(
				(file.size * 16 * 1024) / transferDuration
			);
			console.log(
				`Average transfer bitrate: ${transferBitrate}kb/s over ${transferDuration /
					1000} seconds`
			);

			// File reconstruction
			/**
			 * Example code to reconstruct the file
			 *
			 * This code reconstructs the received data into the original file based on the mime type and extension provided and then downloads the reconstructed file
			 */
			var received = new Blob(file.data, { type: file.mimetype });
			var a = document.createElement('a');
			a.setAttribute('href', URL.createObjectURL(received));
			a.setAttribute('download', `transfer.${file.extension}`);
			var aj = $(a);
			aj.appendTo('body');
			// aj[0].click();
			aj.remove();
		} else if (file.data.length > file.size) {
			file.receiving = false;
			console.error(
				`Received bigger file than advertised: ${file.data.length}/${file.size}`
			);
		}
	}

	function processFreezeFrameMessage(view) {
		// Reset freeze frame if we got a freeze frame message and we are not "receiving" yet.
		if (!freezeFrame.receiving) {
			freezeFrame.receiving = true;
			freezeFrame.valid = false;
			freezeFrame.size = 0;
			freezeFrame.jpeg = undefined;
		}

		// Extract total size of freeze frame (across all chunks)
		freezeFrame.size = new DataView(view.slice(1, 5).buffer).getInt32(0, true);

		// Get the jpeg part of the payload
		let jpegBytes = view.slice(1 + 4);

		// Append to existing jpeg that holds the freeze frame
		if (freezeFrame.jpeg) {
			let jpeg = new Uint8Array(freezeFrame.jpeg.length + jpegBytes.length);
			jpeg.set(freezeFrame.jpeg, 0);
			jpeg.set(jpegBytes, freezeFrame.jpeg.length);
			freezeFrame.jpeg = jpeg;
		}
		// No existing freeze frame jpeg, make one
		else {
			freezeFrame.jpeg = jpegBytes;
			freezeFrame.receiving = true;
			console.log(
				`received first chunk of freeze frame: ${freezeFrame.jpeg.length}/${freezeFrame.size}`
			);
		}

		// Uncomment for debug
		//console.log(`Received freeze frame chunk: ${freezeFrame.jpeg.length}/${freezeFrame.size}`);

		// Finished receiving freeze frame, we can show it now
		if (freezeFrame.jpeg.length === freezeFrame.size) {
			freezeFrame.receiving = false;
			freezeFrame.valid = true;
			console.log(`received complete freeze frame ${freezeFrame.size}`);
			showFreezeFrame();
		}
		// We received more data than the freeze frame payload message indicate (this is an error)
		else if (freezeFrame.jpeg.length > freezeFrame.size) {
			console.error(
				`received bigger freeze frame than advertised: ${freezeFrame.jpeg.length}/${freezeFrame.size}`
			);
			freezeFrame.jpeg = undefined;
			freezeFrame.receiving = false;
		}
	}

	webRtcPlayerObj.onNewVideoTrack = function(streams) {
		if (
			webRtcPlayerObj.video &&
			webRtcPlayerObj.video.srcObject &&
			webRtcPlayerObj.onVideoInitialised
		) {
			webRtcPlayerObj.onVideoInitialised();
		}
	};

	webRtcPlayerObj.onDataChannelMessage = function(data) {
		let view = new Uint8Array(data);

		if (view[0] === ToClientMessageType.QualityControlOwnership) {
			let ownership = view[1] === 0 ? false : true;
			console.log(
				'Received quality controller message, will control quality: ' +
					ownership
			);
			qualityController = ownership;
			// If we own the quality control, we can't relinquish it. We only lose
			// quality control when another peer asks for it
			if (qualityControlOwnershipCheckBox !== null) {
				qualityControlOwnershipCheckBox.disabled = ownership;
				qualityControlOwnershipCheckBox.checked = ownership;
			}
		} else if (view[0] === ToClientMessageType.Response) {
			let response = new TextDecoder('utf-16').decode(data.slice(1));
			for (let listener of responseEventListeners.values()) {
				listener(response);
			}
		} else if (view[0] === ToClientMessageType.Command) {
			let commandAsString = new TextDecoder('utf-16').decode(data.slice(1));
			console.log(commandAsString);
		} else if (view[0] === ToClientMessageType.FreezeFrame) {
			processFreezeFrameMessage(view);
		} else if (view[0] === ToClientMessageType.UnfreezeFrame) {
			invalidateFreezeFrameOverlay();
		} else if (view[0] === ToClientMessageType.VideoEncoderAvgQP) {
			VideoEncoderQP = new TextDecoder('utf-16').decode(data.slice(1));
			//console.log(`received VideoEncoderAvgQP ${VideoEncoderQP}`);
		} else if (view[0] == ToClientMessageType.LatencyTest) {
			let latencyTimingsAsString = new TextDecoder('utf-16').decode(
				data.slice(1)
			);
			console.log('Got latency timings from UE.');
			console.log(latencyTimingsAsString);
			let latencyTimingsFromUE = JSON.parse(latencyTimingsAsString);
			if (webRtcPlayerObj) {
				webRtcPlayerObj.latencyTestTimings.SetUETimings(latencyTimingsFromUE);
			}
		} else if (view[0] == ToClientMessageType.InitialSettings) {
			let settingsString = new TextDecoder('utf-16').decode(data.slice(1));
			let settingsJSON = JSON.parse(settingsString);
			console.log(`Settings JSON ${settingsJSON}`);
		} else if (view[0] == ToClientMessageType.FileExtension) {
			processFileExtension(view);
		} else if (view[0] == ToClientMessageType.FileMimeType) {
			processFileMimeType(view);
		} else if (view[0] == ToClientMessageType.FileContents) {
			processFileContents(view);
		} else {
			console.error(`unrecognized data received, packet ID ${view[0]}`);
		}
	};

	return webRtcPlayerObj.video;
}

function onWebRtcOffer(webRTCData) {
	webRtcPlayerObj.receiveOffer(webRTCData);
}

function onWebRtcAnswer(webRTCData) {
	webRtcPlayerObj.receiveAnswer(webRTCData);
}

function onWebRtcIce(iceCandidate) {
	if (webRtcPlayerObj) {
		webRtcPlayerObj.handleCandidateFromServer(iceCandidate);
	}
}

let styleWidth;
let styleHeight;
let styleTop;
let styleLeft;
let styleCursor = 'default';
let styleAdditional;

function resizePlayerStyleToFillWindow(playerElement) {
	let videoElement = playerElement.getElementsByTagName('VIDEO');

	// Fill the player display in window, keeping picture's aspect ratio.
	let windowAspectRatio = window.innerHeight / window.innerWidth;
	let playerAspectRatio =
		playerElement.clientHeight / playerElement.clientWidth;
	// We want to keep the video ratio correct for the video stream
	let videoAspectRatio = videoElement.videoHeight / videoElement.videoWidth;
	if (isNaN(videoAspectRatio)) {
		//Video is not initialised yet so set playerElement to size of window
		styleWidth = window.innerWidth;
		styleHeight = window.innerHeight;
		styleTop = 0;
		styleLeft = 0;
		playerElement.style =
			'top: ' +
			styleTop +
			'px; left: ' +
			styleLeft +
			'px; width: ' +
			styleWidth +
			'px; height: ' +
			styleHeight +
			'px; cursor: ' +
			styleCursor +
			'; ' +
			styleAdditional;
	} else if (windowAspectRatio < playerAspectRatio) {
		// Window height is the constraining factor so to keep aspect ratio change width appropriately
		styleWidth = Math.floor(window.innerHeight / videoAspectRatio);
		styleHeight = window.innerHeight;
		styleTop = 0;
		styleLeft = Math.floor((window.innerWidth - styleWidth) * 0.5);
		//Video is now 100% of the playerElement, so set the playerElement style
		playerElement.style =
			'top: ' +
			styleTop +
			'px; left: ' +
			styleLeft +
			'px; width: ' +
			styleWidth +
			'px; height: ' +
			styleHeight +
			'px; cursor: ' +
			styleCursor +
			'; ' +
			styleAdditional;
	} else {
		// Window width is the constraining factor so to keep aspect ratio change height appropriately
		styleWidth = window.innerWidth;
		styleHeight = Math.floor(window.innerWidth * videoAspectRatio);
		styleTop = Math.floor((window.innerHeight - styleHeight) * 0.5);
		styleLeft = 0;
		//Video is now 100% of the playerElement, so set the playerElement style
		playerElement.style =
			'top: ' +
			styleTop +
			'px; left: ' +
			styleLeft +
			'px; width: ' +
			styleWidth +
			'px; height: ' +
			styleHeight +
			'px; cursor: ' +
			styleCursor +
			'; ' +
			styleAdditional;
	}
}

function resizePlayerStyleToActualSize(playerElement) {
	let videoElement = playerElement.getElementsByTagName('VIDEO');

	if (videoElement.length > 0) {
		// Display image in its actual size
		styleWidth = videoElement[0].videoWidth;
		styleHeight = videoElement[0].videoHeight;
		let Top = Math.floor((window.innerHeight - styleHeight) * 0.5);
		let Left = Math.floor((window.innerWidth - styleWidth) * 0.5);
		styleTop = Top > 0 ? Top : 0;
		styleLeft = Left > 0 ? Left : 0;
		//Video is now 100% of the playerElement, so set the playerElement style
		playerElement.style =
			'top: ' +
			styleTop +
			'px; left: ' +
			styleLeft +
			'px; width: ' +
			styleWidth +
			'px; height: ' +
			styleHeight +
			'px; cursor: ' +
			styleCursor +
			'; ' +
			styleAdditional;
	}
}

function resizePlayerStyleToArbitrarySize(playerElement) {
	//Video is now 100% of the playerElement, so set the playerElement style
	styleWidth = window.innerWidth;
	styleHeight = window.innerHeight;
	playerElement.style =
		'top: 0px; left: 0px; width: ' +
		styleWidth +
		'px; height: ' +
		styleHeight +
		'px; cursor: ' +
		styleCursor +
		'; ' +
		styleAdditional;
}

function setupFreezeFrameOverlay() {
	freezeFrameOverlay = document.createElement('div');
	freezeFrameOverlay.id = 'freezeFrameOverlay';
	freezeFrameOverlay.style.display = 'none';
	freezeFrameOverlay.style.pointerEvents = 'none';
	freezeFrameOverlay.style.position = 'absolute';
	freezeFrameOverlay.style.zIndex = '20';

	let freezeFrameImage = document.createElement('img');
	freezeFrameImage.style.position = 'absolute';
	freezeFrameOverlay.appendChild(freezeFrameImage);
}

function showFreezeFrameOverlay() {
	if (freezeFrame.valid) {
		freezeFrameOverlay.classList.add('freezeframeBackground');
		freezeFrameOverlay.style.display = 'block';
	}
}

function invalidateFreezeFrameOverlay() {
	freezeFrameOverlay.style.display = 'none';
	freezeFrame.valid = false;
	freezeFrameOverlay.classList.remove('freezeframeBackground');

	if (webRtcPlayerObj) {
		webRtcPlayerObj.setVideoEnabled(true);
	}
}

function resizeFreezeFrameOverlay() {
	if (freezeFrame.width !== 0 && freezeFrame.height !== 0) {
		let displayWidth = 0;
		let displayHeight = 0;
		let displayTop = 0;
		let displayLeft = 0;
		let checkBox = document.getElementById(
			'enlarge-display-to-fill-window-tgl'
		);
		let playerElement = document.getElementById('player');
		if (checkBox !== null && checkBox.checked) {
			// We are fitting video to screen, we care about the screen (window) size
			let windowAspectRatio = window.innerWidth / window.innerHeight;
			let videoAspectRatio = freezeFrame.width / freezeFrame.height;
			if (windowAspectRatio < videoAspectRatio) {
				displayWidth = window.innerWidth;
				displayHeight = Math.floor(window.innerWidth / videoAspectRatio);
				displayTop = Math.floor((window.innerHeight - displayHeight) * 0.5);
				displayLeft = 0;
			} else {
				displayWidth = Math.floor(window.innerHeight * videoAspectRatio);
				displayHeight = window.innerHeight;
				displayTop = 0;
				displayLeft = Math.floor((window.innerWidth - displayWidth) * 0.5);
			}
		} else {
			// Video is coming in at native resolution, we care more about the player size
			let playerAspectRatio =
				playerElement.offsetWidth / playerElement.offsetHeight;
			let videoAspectRatio = freezeFrame.width / freezeFrame.height;
			if (playerAspectRatio < videoAspectRatio) {
				displayWidth = playerElement.offsetWidth;
				displayHeight = Math.floor(
					playerElement.offsetWidth / videoAspectRatio
				);
				displayTop = Math.floor(
					(playerElement.offsetHeight - displayHeight) * 0.5
				);
				displayLeft = 0;
			} else {
				displayWidth = Math.floor(
					playerElement.offsetHeight * videoAspectRatio
				);
				displayHeight = playerElement.offsetHeight;
				displayTop = 0;
				displayLeft = Math.floor(
					(playerElement.offsetWidth - displayWidth) * 0.5
				);
			}
		}
		let freezeFrameImage = document.getElementById('freezeFrameOverlay')
			.childNodes[0];
		freezeFrameOverlay.style.width = playerElement.offsetWidth + 'px';
		freezeFrameOverlay.style.height = playerElement.offsetHeight + 'px';
		freezeFrameOverlay.style.left = 0 + 'px';
		freezeFrameOverlay.style.top = 0 + 'px';

		freezeFrameImage.style.width = displayWidth + 'px';
		freezeFrameImage.style.height = displayHeight + 'px';
		freezeFrameImage.style.left = displayLeft + 'px';
		freezeFrameImage.style.top = displayTop + 'px';
	}
}

function resizePlayerStyle() {
	let playerElement = document.getElementById('player');

	if (!playerElement) {
		return;
	}

	updateVideoStreamSize();

	let checkBox = { checked: true };
	let windowSmallerThanPlayer =
		window.innerWidth < playerElement.videoWidth ||
		window.innerHeight < playerElement.videoHeight;
	if (checkBox !== null) {
		if (checkBox.checked || windowSmallerThanPlayer) {
			resizePlayerStyleToFillWindow(playerElement);
		} else {
			resizePlayerStyleToActualSize(playerElement);
		}
	} else {
		resizePlayerStyleToArbitrarySize(playerElement);
	}
}

function updateVideoStreamSize() {
	if (!matchViewportResolution) {
		return;
	}

	let now = new Date().getTime();
	if (now - lastTimeResized > 1000) {
		let playerElement = document.getElementById('player');
		if (!playerElement) {
			return;
		}

		let descriptor = {
			ConsoleCommand: 'setres ' + playerElement.clientWidth + 'x' + playerElement.clientHeight
		};
		emitCommand(descriptor);
		console.log(descriptor);
		lastTimeResized = new Date().getTime();
	} else {
		console.log('Resizing too often - skipping');
		clearTimeout(resizeTimeout);
		resizeTimeout = setTimeout(updateVideoStreamSize, 1000);
	}
}

// Must be kept in sync with PixelStreamingProtocol::EToUE4Msg C++ enum.
const MessageType = {
	/**********************************************************************/

	/*
	 * Control Messages. Range = 0..49.
	 */
	IFrameRequest: 0,
	RequestQualityControl: 1,
	FpsRequest: 2,
	AverageBitrateRequest: 3,
	StartStreaming: 4,
	StopStreaming: 5,
	LatencyTest: 6,
	RequestInitialSettings: 7,

	/**********************************************************************/

	/*
	 * Input Messages. Range = 50..89.
	 */

	// Generic Input Messages. Range = 50..59.
	UIInteraction: 50,
	Command: 51,

	// Keyboard Input Message. Range = 60..69.
	KeyDown: 60,
	KeyUp: 61,
	KeyPress: 62,

	// Mouse Input Messages. Range = 70..79.
	MouseEnter: 70,
	MouseLeave: 71,
	MouseDown: 72,
	MouseUp: 73,
	MouseMove: 74,
	MouseWheel: 75,

	// Touch Input Messages. Range = 80..89.
	TouchStart: 80,
	TouchEnd: 81,
	TouchMove: 82,

	// Gamepad Input Messages. Range = 90..99
	GamepadButtonPressed: 90,
	GamepadButtonReleased: 91,
	GamepadAnalog: 92

	/**************************************************************************/
};

// A generic message has a type and a descriptor.
function emitDescriptor(messageType, descriptor) {
	// Convert the dscriptor object into a JSON string.
	let descriptorAsString = JSON.stringify(descriptor);

	// Add the UTF-16 JSON string to the array byte buffer, going two bytes at
	// a time.
	let data = new DataView(
		new ArrayBuffer(1 + 2 + 2 * descriptorAsString.length)
	);
	let byteIdx = 0;
	data.setUint8(byteIdx, messageType);
	byteIdx++;
	data.setUint16(byteIdx, descriptorAsString.length, true);
	byteIdx += 2;
	for (let i = 0; i < descriptorAsString.length; i++) {
		data.setUint16(byteIdx, descriptorAsString.charCodeAt(i), true);
		byteIdx += 2;
	}
	sendInputData(data.buffer);
}

// A build-in command can be sent to UE4 client. The commands are defined by a
// JSON descriptor and will be executed automatically.
// The currently supported commands are:
//
// 1. A command to run any console command:
//    "{ ConsoleCommand: <string> }"
//
// 2. A command to change the resolution to the given width and height.
//    "{ Resolution.Width: <value>, Resolution.Height: <value> } }"
//
function emitCommand(descriptor) {
	emitDescriptor(MessageType.Command, descriptor);
}

function requestInitialSettings() {
	sendInputData(new Uint8Array([MessageType.RequestInitialSettings]).buffer);
}

function requestQualityControl() {
	if (!qualityController) {
		sendInputData(new Uint8Array([MessageType.RequestQualityControl]).buffer);
	}
}

// function start(pixelStreamingServerUrl) {
// if (!connect_on_load || is_reconnection) {
// 	showConnectOverlay();
// 	invalidateFreezeFrameOverlay();
// 	shouldShowPlayOverlay = true;
// 	resizePlayerStyle();
// } else {
// 	connect(pixelStreamingServerUrl);
// }
// }

function connect(el, pixelStreamingServerUrl) {
	const ws = new WebSocket(pixelStreamingServerUrl);

	ws.onopen = function() {};

	ws.onmessage = function(event) {
		let msg = JSON.parse(event.data);
		if (msg.type === 'config') {
			console.log(
				'%c[Inbound SS (config)]',
				'background: lightblue; color: black',
				msg
			);
			setupPlayerForStreaming(ws, el, msg);
		} else if (msg.type === 'playerCount') {
			console.log(
				'%c[Inbound SS (playerCount)]',
				'background: lightblue; color: black',
				msg
			);
		} else if (msg.type === 'offer') {
			console.log(
				'%c[Inbound SS (offer)]',
				'background: lightblue; color: black',
				msg
			);
			onWebRtcOffer(msg);
		} else if (msg.type === 'answer') {
			console.log(
				'%c[Inbound SS (answer)]',
				'background: lightblue; color: black',
				msg
			);
			onWebRtcAnswer(msg);
		} else if (msg.type === 'iceCandidate') {
			onWebRtcIce(msg.candidate);
		} else if (msg.type === 'warning' && msg.warning) {
			console.warn(msg.warning);
		} else {
			console.error('Invalid SS message type', msg.type);
		}
	};

	ws.onerror = function(event) {
		console.log(`WS error: ${JSON.stringify(event)}`);
	};

	ws.onclose = function(event) {
		console.log(`WS closed: ${JSON.stringify(event.code)} - ${event.reason}`);

		// destroy `webRtcPlayerObj` if any
		if (webRtcPlayerObj) {
			el.removeChild(webRtcPlayerObj.video);
			webRtcPlayerObj.close();
			webRtcPlayerObj = undefined;
		}

		// setTimeout(() => connect(el, pixelStreamingServerUrl), 5000);
	};

	return ws;
}

// Config data received from WebRTC sender via the Cirrus web server
function setupPlayerForStreaming(ws, el, config) {
	setupWebRtcPlayer(ws, el, config);
	resizePlayerStyle();
}

export function setup(el, pixelStreamingServerUrl) {
	setupHtmlEvents();
	setupFreezeFrameOverlay();
	return connect(el, pixelStreamingServerUrl);
}
